import { render, staticRenderFns } from "./ArticleCategoryPage.vue?vue&type=template&id=e5caf076&"
import script from "./ArticleCategoryPage.vue?vue&type=script&lang=js&"
export * from "./ArticleCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports